import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin-top: 24px;
`;

export const Items = styled.ul`
  list-style: none;
  width: 100%;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const Item = styled.li`
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: 8px;

  button {
    margin-top: 3px;
  }

  .name {
    color: #1971c2;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%; /* 19.6px */
  }

  .meta {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;

    li {
      margin-top: 15px;
      color: #000;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 140%; /* 16.8px */
    }
  }

  .badge {
    color: #868e96;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%; /* 16.8px */
    padding: 4px 8px;
    border-radius: 4px;
    background: #f8f9fa;
  }
`;

export const Actions = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;

  button {
    border-color: #228be6;
    color: #228be6;
  }
`;

export const ToggleButton = styled.button`
  margin-top: 3px;
  transform: rotate(0deg);
  transition: transform 0.2s ease;

  &[data-is-open='true'] {
    margin-top: 1px;
    transform: rotate(180deg);
  }
`;
